import { Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, lede, testid = "page-hero" }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden border-b border-line">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(15,23,42,0.045) 1px, transparent 1px)",
          backgroundSize: "25% 100%",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-6 pb-16 pt-32 sm:pb-20 sm:pt-40">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-slate-500">
            <span className="h-px w-10 bg-slate-300" aria-hidden="true" />
            {eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="max-w-3xl font-serif text-4xl leading-[1.06] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            {title}
          </h1>
        </Reveal>
        {lede && (
          <Reveal delay={0.16}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
              {lede}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
